import { REGISTRY_ADDED, REGISTRY_SET, REGISTRY_DELETED, REGISTRY_EDITED } from 'src/app/redux/redux-types';
import { reduxRegistryTypes } from 'src/types';

export const registryDefaultState: reduxRegistryTypes.StateType = {
  registryList: [],
};

export const registryReducer = (
  state = registryDefaultState,
  action: reduxRegistryTypes.ActionType,
): reduxRegistryTypes.StateType => {
  switch (action.type) {
    case REGISTRY_SET:
      return {
        ...state,
        registryList: action.payload,
      };
    case REGISTRY_ADDED:
      // eslint-disable-next-line no-case-declarations
      const exists = state.registryList.some((item) => item.id === action.payload.id);
      if (exists) {
        return state;
      }
      return {
        ...state,
        registryList: [action.payload, ...state.registryList],
      };
    case REGISTRY_EDITED:
      // eslint-disable-next-line no-case-declarations
      const updateIndex = state.registryList.findIndex((obj) => obj.id === action.payload.id);
      return {
        ...state,
        registryList: [
          ...state.registryList.slice(0, updateIndex),
          action.payload,
          ...state.registryList.slice(updateIndex + 1),
        ],
      };
    case REGISTRY_DELETED:
      return {
        ...state,
        registryList: state.registryList.filter((o) => o.id !== action.payload),
      };
    default:
      return state;
  }
};
